import { select } from 'd3-selection'
import { iconTrash } from '../icons'
import { onTrashClick } from '../onTrashClick'

/**
 * @param {string} fileName 
 * @param {string} filePath 
 * @param {number | null} fileId
 * @param {string} icon 
 * @param {boolean} trashHidden
 */
export const addToHTMLList = (fileName, filePath, fileId, icon, trashHidden) =>
  select('#fileList')
    .style('margin-top', '8px')
    .clas('row')
    .style('display', 'grid')
    .style('grid-template-columns', 'repeat(auto-fill, 283px)')
    .style('justify-content', 'space-evenly')
    .style('margin', '4px')
    .div()
    .clas('file-anchor shadow-sm')
    .call(cell => cell.div()
      .clas('file-row')
      .style('display', 'flex')
      .call(div => {
        div.div()
          .style('margin-right', '3px')
          .clas('file-prepend')
          .append('i')
          .clas(icon)
        div.append('a')
          .text(fileName)
          .attr('href', filePath)
          .style('color', 'black')
          .style('overflow-wrap', 'break-word')
          .style('min-width', '215px')
          .style('max-width', '215px')
          .clas('stretched-link')
        div.div()
          .clas('trash')
          .style('visibility', trashHidden ? 'hidden' : 'visible')
          .style('cursor', 'pointer')
          .call(div => {
            if (fileId !== null) {
              div.onclick(() => onTrashClick(cell, fileId, fileName))
            }
          })
          .append('i')
          .clas(iconTrash)
      })
    )